import { useState } from 'react';

import { clockTime } from '../../shared/lib/format';
import { ErrorState, LoadingState } from '../../shared/ui/states';
import { BudgetCard } from './budget-card';
import { RunsOutCard } from './runs-out-card';
import { SpendTable } from './spend-table';
import { TodayCard } from './today-card';
import { useAiBudget, useAiUsage } from './use-ai-budget';

interface IAiUsagePanelProps {
  editable: boolean;
  now: number;
  timeZone?: string;
}

/** Board S4: what AI steps cost, and the daily limit on it; owner and admin set the limit. */
export const AiUsagePanel = ({ editable, now, timeZone }: IAiUsagePanelProps) => {
  const budget = useAiBudget();
  const usage = useAiUsage('today');
  const [focus, setFocus] = useState(0);
  const { today } = budget;

  if (today.isError) return <ErrorState error={today.error} onRetry={() => void today.refetch()} />;
  if (today.isPending) return <LoadingState rows={6} />;

  return (
    <div className="flex flex-col gap-5">
      <TodayCard
        today={today.data}
        ranOutAt={usage.data?.ranOutAt ?? null}
        now={now}
        timeZone={timeZone}
        editable={editable}
        onRaise={() => setFocus((n) => n + 1)}
      />
      <div className="grid grid-cols-2 items-start gap-5">
        <BudgetCard
          key={`${today.data.configuredUsd ?? 'default'}`}
          today={today.data}
          budget={budget}
          editable={editable}
          focusSignal={focus}
        />
        <RunsOutCard reset={clockTime(today.data.resetsAt, 'UTC')} />
      </div>
      <SpendTable />
    </div>
  );
};
